import { render, staticRenderFns } from "./BtnMore.vue?vue&type=template&id=964097ac"
import script from "./BtnMore.vue?vue&type=script&lang=js"
export * from "./BtnMore.vue?vue&type=script&lang=js"
import style0 from "./BtnMore.vue?vue&type=style&index=0&id=964097ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports